import CheckinScanner from "@/pages/CheckinScanner";
export default function StudentCheckin() {
  return <CheckinScanner kind="student" />;
}
